<template>
  <v-dialog @click:outside="$store.dispatch('setDialog', null)"
            :fullscreen="dialog.fullscreen"
            :max-width="dialog.width"
            v-model="dialog.show">
    <v-card flat tile>
      <v-card-title>{{ dialog.title }}</v-card-title>
      <v-card-subtitle>{{ dialog.subtitle }}</v-card-subtitle>
      <v-card-text>
        <component :is="dialog.component"></component>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalComponent',
  props: {
    dialog: null
  }
}
</script>

<style scoped>

</style>
